import { Component, ojs, app, v, state, payload } from "modular-openscriptjs";
import {
    closeModal,
    either,
    formatThousand,
    cleanDispose,
} from "../../helpers";
import { $e } from "../../ojs.events";
import { dom, tool } from "../../fotastart";

const h = app("h");
const broker = app("broker");

export default class DepositAiCreditForm extends Component {
    selectedAmount = state(0);

    get rate() {
        return window.systemConfigs?.aiCreditRate ?? 0.25;
    }

    tiers = [100, 200, 500, 1000, 2500, 5000];

    render(...args) {
        return h.empty();
    }

    $$aiCredit = {
        needs: {
            depositForm: (ed, event) => this.showForm(ed, event),
        },
    };

    holder = null;

    closeForm() {
        if (this.holder) {
            this.holder.hide();
        }
    }

    async showForm(ed, event) {
        if (this.holder) {
            cleanDispose(this.holder);
        }

        this.holder = tool.plainModal(
            h.div(
                {
                    id: "deposit-ai-credit-modal",
                    class: "modal-content border-0 shadow-lg",
                    style: "background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%); border-radius: 24px;",
                },
                h.div({ class: "modal-body p-0" }, this.renderForm()),
                h.div({class: 'modal-footer'}, this.renderFooter())
            ),
        );

        this.holder.show();
    }

    renderForm(...args) {
        return h.div(
            {
                class: "p-4 position-relative overflow-hidden d-flex flex-column w-100",
            },
            h.style(`
                .abstract-shape {
                    position: absolute;
                    border-radius: 50%;
                    filter: blur(60px);
                    animation: float-shapes 20s infinite alternate ease-in-out;
                    opacity: 0.5;
                    z-index: 0;
                }
                .shape-1 {
                    width: 350px;
                    height: 350px;
                    background: rgba(151, 62, 135, 0.4);
                    top: -100px;
                    left: -100px;
                    animation-delay: 0s;
                }
                .shape-2 {
                    width: 450px;
                    height: 450px;
                    background: rgba(212, 154, 42, 0.4);
                    bottom: -150px;
                    right: -150px;
                    animation-delay: -5s;
                    animation-direction: alternate-reverse;
                }
                .shape-3 {
                    width: 250px;
                    height: 250px;
                    background: rgba(151, 62, 135, 0.3);
                    top: 30%;
                    right: -100px;
                    animation-delay: -10s;
                }
                .shape-4 {
                    width: 300px;
                    height: 300px;
                    background: rgba(212, 154, 42, 0.4);
                    bottom: 10%;
                    left: -50px;
                    animation-delay: -15s;
                    animation-direction: alternate-reverse;
                }
                @keyframes float-shapes {
                    0% { transform: translate(0, 0) scale(1) rotate(0deg); }
                    33% { transform: translate(40px, -40px) scale(1.1) rotate(10deg); }
                    66% { transform: translate(-30px, 30px) scale(0.95) rotate(-10deg); }
                    100% { transform: translate(0, 0) scale(1) rotate(0deg); }
                }
                .tier-card {
                    background: rgba(255, 255, 255, 0.75) !important;
                    backdrop-filter: blur(20px);
                    -webkit-backdrop-filter: blur(20px);
                    border: 1px solid rgba(255, 255, 255, 0.9) !important;
                    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
                    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
                }
                .tier-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 12px 25px rgba(151, 62, 135, 0.15);
                    border-color: rgba(151, 62, 135, 0.4) !important;
                    background: rgba(255, 255, 255, 0.98) !important;
                }
                .tier-card.selected {
                    background: linear-gradient(135deg, #ffffff 0%, #fffbf0 100%) !important;
                    border: 2px solid #973e87 !important;
                    box-shadow: 0 10px 25px rgba(151, 62, 135, 0.25);
                    transform: scale(1.04);
                    z-index: 2;
                }
                .tier-card.selected .badge {
                    background-color: #973e87 !important;
                    color: white !important;
                    border: none !important;
                }
                .tier-card.selected h3 {
                    color: #973e87 !important;
                }
            `),

            // Background Abstract Shapes Container
            h.div(
                {
                    class: "position-absolute top-0 start-0 w-100 h-100 pe-none z-0",
                    style: "overflow: hidden;",
                },
                h.div({ class: "abstract-shape shape-1" }),
                h.div({ class: "abstract-shape shape-2" }),
                h.div({ class: "abstract-shape shape-3" }),
                h.div({ class: "abstract-shape shape-4" }),
            ),

            // Close Button
            h.button(
                {
                    class: "btn border rounded-circle position-absolute d-flex align-items-center justify-content-center",
                    style: "top: 25px; right: 25px; width: 40px; height: 40px; background: rgba(255,255,255,0.6); backdrop-filter: blur(4px); z-index: 1000;",
                    onclick: this.method("closeForm"),
                },
                h.i({ class: "bi bi-x-lg text-dark fw-bold" }),
            ),

            // Content Container (z-index: 1 to be above the wavy lines)
            h.div(
                {
                    class: "position-relative z-1 d-flex flex-column h-100 w-100",
                },
                h.div(
                    { class: "text-center mb-4 mt-2" },
                    h.h4(
                        {
                            class: "fw-bold text-dark mb-2 d-flex align-items-center justify-content-center gap-2",
                        },
                        h.i({ class: "bi bi-stars text-warning" }),
                        "Top-up AI Credits",
                    ),
                    h.p(
                        { class: "text-muted small mb-0" },
                        `Select a package to Power your Experience with AI!`,
                    ),
                ),

                h.div(
                    { class: "row g-3 flex-grow-1" },
                    this.tiers.map((credits) => {
                        const price = credits * this.rate;

                        return v(
                            this.selectedAmount,
                            (amt) =>
                                h.div(
                                    {
                                        class: `card tier-card rounded-4 cursor-pointer text-center h-100 ${
                                            amt.value === credits
                                                ? "selected"
                                                : ""
                                        }`,
                                        listeners: {
                                            click: () => {
                                                this.selectedAmount.value =
                                                    credits;
                                            },
                                        },
                                    },
                                    h.div(
                                        {
                                            class: "card-body p-3 d-flex flex-column justify-content-center",
                                        },
                                        h.div(
                                            {
                                                class: "d-flex align-items-center justify-content-center mb-1 gap-1",
                                            },
                                            h.h3(
                                                {
                                                    class: "fw-bold mb-0 text-dark transition-all",
                                                },
                                                formatThousand(credits),
                                            ),
                                        ),
                                        h.span(
                                            {
                                                class: "text-secondary fw-semibold mb-3",
                                                style: "font-size: 0.75rem; letter-spacing: 0.5px; text-transform: uppercase;",
                                            },
                                            "Credits",
                                        ),
                                        h.div(
                                            {
                                                class: "badge rounded-pill fw-bold shadow-sm py-2 px-3 mx-auto mt-auto border transition-all text-dark",
                                                style: "font-size: 0.85rem; background: white;",
                                            },
                                            `KES ${formatThousand(price)}`,
                                        ),
                                    ),
                                ),
                            { $class: "col-6 col-sm-4" },
                        );
                    }),
                ),
            ),
            ...args,
        );
    }

    renderFooter() {
        return h.div(
            {class: 'w-100 p-0'},
            v(this.selectedAmount, (amt) =>
                h.button(
                    {
                        class: `btn w-100 rounded-pill py-3 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2 transition-all ${
                            amt.value === 0
                                ? "btn-light text-muted border border-2"
                                : "btn-primary"
                        }`,
                        style: "font-size: 1.1rem;",
                        listeners: {
                            click: () => {
                                if (amt.value === 0) return;

                                broker.send(
                                    $e.aiCredit.needs.purchase,
                                    payload(
                                        {
                                            credits: amt.value,
                                        },
                                        { next: "user.ai-credits" },
                                    ),
                                );

                                this.closeForm();
                            },
                        },
                    },
                    either(amt.value === 0, { disabled: true }),
                    amt.value === 0
                        ? h.span("Select a Package")
                        : h.span(
                              `Pay KES ${formatThousand(amt.value * this.rate)}`,
                          ),
                    amt.value === 0
                        ? h.i({ class: "bi bi-arrow-right" })
                        : h.i({ class: "bi bi-shield-lock-fill" }),
                ),
            ),
        );
    }
}

ojs(DepositAiCreditForm);
